import React from 'react';

const PhoneNumber = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.0087 1.86939C3.92895 -0.0508521 7.16944 0.0951259 8.50647 2.4909L9.24825 3.82007C10.1214 5.38457 9.74932 7.35855 8.47115 8.65234C8.45412 8.67567 8.36383 8.80703 8.35263 9.03654C8.33834 9.32952 8.44235 10.007 9.49204 11.0567C10.5414 12.1061 11.2188 12.2104 11.512 12.1962C11.7417 12.1849 11.8732 12.0948 11.8965 12.0776C13.1903 10.7996 15.1643 10.4274 16.7288 11.3005L18.0579 12.0424C20.4537 13.3795 20.5997 16.6198 18.6795 18.5401C17.6523 19.5672 16.2866 20.4798 14.6816 20.5408C12.3033 20.6309 8.354 20.0167 4.44308 16.1057C0.53212 12.1948 -0.0820835 8.24559 0.0080731 5.86719C0.0689242 4.26226 0.981565 2.89652 2.0087 1.86939ZM7.00942 3.3264C6.32471 2.09961 4.4849 1.81777 3.22099 3.08168C2.33479 3.96787 1.75867 4.94602 1.72129 5.93214C1.64609 7.91556 2.13578 11.3739 5.65537 14.8934C9.17499 18.413 12.6332 18.9027 14.6167 18.8275C15.6029 18.7901 16.581 18.214 17.4672 17.3278C18.731 16.0639 18.4492 14.2241 17.2224 13.5395L15.8933 12.7977C15.0665 12.3362 13.905 12.4937 13.0897 13.3089C13.0096 13.3889 12.4999 13.8646 11.5953 13.9086C10.6692 13.9537 9.54828 13.5375 8.27982 12.2691C7.01091 11.0002 6.59487 9.87892 6.64025 8.95271C6.6846 8.04804 7.1603 7.53873 7.23985 7.45913C8.05512 6.64383 8.21262 5.4824 7.7512 4.65557L7.00942 3.3264Z"
        fill={color}
      />
    </svg>
  );
};

export default PhoneNumber;
